<template>
  <div class="lsx-history">
    <table class="history table table-sm table-bordered">
      <thead>
        <tr>
          <th width="77">Date</th>
          <th width="77">Opening<br>Index</th>
          <th width="77">Closing<br>Index</th>
          <th>Change</th>
          <th width="65">High</th>
          <th width="65">Low</th>
          <th width="80">Trading<br>Value<br>(LAK)</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in items" :key="item.date">
          <td>{{ item.date | dateFormat }}</td>
          <td>{{ item.price.open | amountFormat }}</td>
          <td>{{ item.price.close | amountFormat }}</td>
          <td :class="[{'text-success': isUp(item.price)}, {'text-danger': isDown(item.price)}]">
            <span v-if="isUp(item.price)"><img src="@/assets/theme/ico_up.gif"></span>
            <span v-else-if="isDown(item.price)"><img src="@/assets/theme/ico_down.gif"></span>
            {{ item.price.change | amountFormat }}({{ item.price.percent | amountFormat }}%)
          </td>
          <td>{{ item.price.high | amountFormat }}</td>
          <td>{{ item.price.low | amountFormat }}</td>
          <td>{{ item.price.val | amountFormat(0) }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
import moment from '@/moment'

export default {
  name: 'LSXHistory',
  props: ['data'],
  computed: {
    items() {
      return (this.data || [])
    }
  },
  methods: {
    isUp(price) {
      return price.open < price.close
    },
    isDown(price) {
      return price.open > price.close
    }
  },
  filters: {
    dateFormat(date) {
      return moment(date).format("YYYY/MM/DD")
    }
  }
}
</script>
<style lang="scss">
.lsx-history {
  // overflow: scroll;

  table.history {
    thead {
      background-color: #F8F8F8;
      border-top: 2px solid #396DB4;

      tr {
        th {
          font-size: 75%;
          text-align: center;
          padding: 5px 0;
          vertical-align: middle;
          color: #396DB4;
        }
      }
    }

    tbody {
      tr {
        td {
          font-size: 80%;
          text-align: center;
          padding: 5px 2px;
        }
      }
    }
  }
}
</style>
